import PasskeyManager from '../account/PasskeyManager';

export default function MobileAccountPasskeys() {
  return (
    <div className="mobile-account-profile">
      <PasskeyManager compact />
    </div>
  );
}
